import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import 'whatwg-fetch';
import { connect } from 'react-redux';
import debounce from 'debounce';
import { trackMapFindClosest } from '../../utils/analytics';

import {
    sortByDistance
} from '../../utils/sortByDistance';
import * as actionCreators from '../../actions/actionCreators';
import { getDistanceMatrixClosestItem } from '../../api';

import { CENTER_ZOOM } from '../../constants/map';

class MapClosestButton extends PureComponent {
    findClosestMachine = () => {
        const {
            userPos,
            items,
            filteredItems,
            labels,
        } = this.props;

        if (!userPos) {
            alert(labels.allowGeoPos);
            return;
        }

        const itemsToSearch = filteredItems.length
            ? filteredItems
            : items;

        const newUrl = `${window.location.origin}${window.location.pathname}`;
        history.pushState({}, null, newUrl);

        this.debouncedGetClosestItem(userPos, itemsToSearch)
        trackMapFindClosest();
    }

    getClosestItem = (userPos, itemsToSearch) => {
        const {
            openMarker,
            setCenter,
            setZoom,
            zoom,
        } = this.props;

        getDistanceMatrixClosestItem(userPos, itemsToSearch)
            .then(result => {
                let closestItem;

                if(result.status === 'ok') {
                    closestItem = result.data.closestItem;
                } else { // fallback to naive distance if dist matrix api is unavailable
                    const sorted = sortByDistance({
                        x: userPos.lng,
                        y: userPos.lat
                    }, itemsToSearch);

                    closestItem = sorted[0];

                }

                const center = {
                    lat: closestItem.point.coordinates[1],
                    lng: closestItem.point.coordinates[0],
                };

                setCenter(center);

                setZoom(Math.max(CENTER_ZOOM, zoom));
                openMarker(closestItem)
            });
    }

    debouncedGetClosestItem = debounce(this.getClosestItem, 3000, true)

    render() {
        const { labels, userPosError  } = this.props;

        if (userPosError && userPosError.code === userPosError.PERMISSION_DENIED) {
            return (
                <button
                    className="Layout__RePosition Layout__RePosition--Disabled"
                    disabled
                >
                    {labels.geoPosDisabled}
                </button>
            );
        }

        return (
            <button
                className="Layout__RePosition"
                onClick={this.findClosestMachine}
                tabIndex="0"
            >
                {labels.findNearest}
            </button>
        );
    }
}

function mapStateToProps(state) {
    return {
        items: state.map.items,
        filteredItems: state.map.filteredItems,
        userPos: state.map.userPos,
        userPosError: state.map.userPosError,
        zoom: state.map.zoom,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MapClosestButton);

